// extracted by mini-css-extract-plugin
export var body = "formOverlay-module--body--TdZiX";
export var close = "formOverlay-module--close--UYKoP";
export var closeIcon = "formOverlay-module--close-icon--oX4v6";
export var content = "formOverlay-module--content--I5+zx";
export var dialog = "formOverlay-module--dialog--FB2mG";
export var specialBackground = "formOverlay-module--special-background--8FMg8";
export var specialBackgroundContainer = "formOverlay-module--special-background-container--uCggC";
export var wrapper = "formOverlay-module--wrapper--U+HQB";